import React from "react";
import { GriddleComponents } from "griddle-react";

export const Layout = (props: GriddleComponents) => (
    <div>
        <props.Filter />
        <div className="table-responsive">
            <props.Table />
        </div>
        <props.Pagination />
    </div>
);
